import React from "react";
import { ICONS } from "../../../constants/enums";
import { Spinner } from "../../Common/Spinner";
import DisplaySection from "../../MoneyTransfer/DisplaySection";
import Alert from "../../Common/Alerts/Alert";

// types
import type { SendMoneyQuote } from "../../../types/sendMoney";

interface SendMoneyQuoteDisplayProps {
  loading: boolean;
  quote: SendMoneyQuote | null;
}

const SendMoneyQuoteDisplay = ({
  loading,
  quote,
}: SendMoneyQuoteDisplayProps): React.ReactElement => {
  if (loading) {
    return (
      <div className="flex-col align-items-center justify-content-center gap-8">
        <Spinner show className="lds-ring--lg realtime-loading" />
        <p className="quote-updating__text">Updating...</p>
      </div>
    );
  }

  if (!quote) {
    return (
      <Alert
        alertClasses="alert-info flex-row align-items-center gap-8"
        textClasses="font-size-lg"
        message="Enter the amount to send."
        icon={ICONS.INFO}
      />
    );
  }

  return (
    <DisplaySection
      variant="plain"
      sections={[
        { name: "quote", id: "quote", label: "", fields: quote.displayFields },
      ]}
    />
  );
};

export default SendMoneyQuoteDisplay;